import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
// import Login from './pages/Login';
import GlobalProvider from './services/auth/authContext';
import AppRouter from './AppRouter';

ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      {/* <Login /> */}
      <AppRouter />
    </GlobalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-thumbs.js');
  });
}